import getApiHeaders from './apiHeaders';

const getApiBaseUrl = () => {
    if (process.env.REACT_APP_API_URL) return process.env.REACT_APP_API_URL;
    const { hostname } = window.location;
    if (hostname === 'localhost' || hostname === '127.0.0.1' || /^192\.168\./.test(hostname) || /^10\./.test(hostname) || /^100\./.test(hostname)) {
        return `http://${hostname}:5000`;
    }
    return "https://www.nodecharm.com";
};

export async function deleteFileFromServer(fileId) {
    const response = await fetch(`${getApiBaseUrl()}/api/file/${encodeURIComponent(fileId)}`, {
        method: 'DELETE',
        headers: getApiHeaders(),
    });
    if (!response.ok) {
        if (response.status === 404) {
            return { success: true, alreadyDeleted: true };
        }
        throw new Error(`Failed to delete file: ${response.statusText}`);
    }
    return response.json();
}
